import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    count: 0,
    info: {},
    isLoading: true,
    contentId: '', //全局用户id
    loginStatus: 0, //登录状态 0 未登录 1 已登录
    instanceId: 0,   //会议ID
    selectedStatus: false,  //是否为已报名的会议
    Todynum: 0,   //当前会议状态（0为未直播，1为今日直播，2为正在直播，3为直播结束）
    isForeshow: 1, //前会议是否为预告 （1为预告，2为回放）
    isRegistering: 0, //是否有注册弹窗 0 否 1 注册弹窗 2 补全信息弹窗
    bannerImgUrl: "",
  },
  mutations: {
    increment(state, count) {
      state.count += count;
    },
    setContentId(state, contentId) {
      state.contentId = contentId;
    },
    setIsRegistering(state, isRegister) {
      state.isRegistering = isRegister;
    },
    setLoginStatus(state, status) {
      state.loginStatus = status;
    },
    setUserInfo(state, info) {
      state.info = info;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    getinstanceId(state, status) {
      state.instanceId = status;
    },
    getselectedStatus(state, status) {
      state.selectedStatus = status;
    },
    getTodynum(state, status) {
      state.Todynum = status;
    },
    getisForeshow(state, status) {
      state.isForeshow = status;
    },
    setBannerImgUrl(state, bannerImgUrl) {
      state.bannerImgUrl = bannerImgUrl;
    },
  },
  actions: {}
});
